import { render, staticRenderFns } from "./SelectableSaleTaxes.vue?vue&type=template&id=74f8c54c&"
import script from "./SelectableSaleTaxes.vue?vue&type=script&lang=ts&"
export * from "./SelectableSaleTaxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports